





























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PickingView extends Vue {
  public items: Common.Picking[] = new Array(0);
  public params: Common.PickingQuery = new Common.PickingQuery();
  public sortOptions: any = [
    { value: 'State', text:'状態' },    
    { value: 'pickingNo', text: 'ピッキング番号' },
    { value: 'deliveryDate', text: '出荷日' },    
    { value: 'warehouse', text: '倉庫' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },        
  ];
  public savingFlag: Common.PickingStatus = Common.PickingStatus.WaitPicking;
  public voucherTypes = Common.voucherTypes;  
  @Prop() public pickingNo:string;

  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.picking) > 0 ;
  }

  public created() {
    // 検索条件を設定する
    if(this.pickingNo) {
      this.params.pickingNo = this.pickingNo;
      this.params.state = null;
		}            

    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    // //棚卸処理明細タブのリロード
    // (this.$refs.stockTakingItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelected(index: number, selected: Common.Picking) {

  }
  // 棚卸処理明細一覧を表示
  public showDeliveries() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.Picking;
    let routeData = this.$router.resolve(String.format('/sales/SalesDelivery?pickingNo={0}',obj.pickingNo));
    window.open(routeData.href, '_blank');
  }
  
}
